import type { MediaScreen } from './DefaultMediaMatchProvider';

/**
 * Representative viewport widths per device category.
 *
 * Used by useMediaQuery and useResponsive to simulate media query matching
 * during SSR when window.matchMedia is unavailable.
 *
 * Values represent typical device widths for each screen category,
 * matching the breakpointAliasPx thresholds in the joykit theme:
 * - mobile: 25 (400px) — between xxs (375px) and xs (480px)
 * - tablet: 52 (832px) — between sm2 (768px) and sm3 (840px)
 * - desktop: 90 (1440px) — matches lg breakpoint
 *
 * Units are relative (em/rem are numerically equivalent at root font size).
 */
export const mediaScreenWidths: Record<MediaScreen, number> = {
  mobile: 25,
  tablet: 52,
  desktop: 90,
};
